export const step4Styles = {
  width: "100%",
  boxSizing: "border-box",
  padding: "0 2rem 1rem 2rem",
  "& .step4-title": {
    color: "#8f8f8f",
    fontWeight: 500,
    letterSpacing: "0.2px",
    marginBottom: 0,
  },
  "& .step4-meta-compact": {
    display: "grid",
    gridTemplateColumns: "350px minmax(0, 1fr)",
    gap: "16px",
    padding: "10px 14px",
    border: "1px solid #ececec",
    borderRadius: "8px",
    background: "#fafafa",
    flex: "1 1 600px",
    minWidth: 0,
    maxWidth: "100%",
    marginTop: "10px",
  },
  "& .step4-meta-summary": {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  "& .step4-meta-line": {
    display: "flex",
    gap: "24px",
  },
  "& .step4-meta-line > div": {
    display: "flex",
    flexDirection: "column",
    minWidth: "160px",
  },
  "& .step4-meta-line > div:last-of-type": {
    flex: 1,
    minWidth: 0,
  },
  "& .step4-meta-label": {
    fontSize: "10.5px",
    fontWeight: 600,
    color: "#b4b4b4",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
  },
  "& .step4-meta-value": {
    fontSize: "12px",
    fontWeight: 500,
    color: "#2f55d4",
    lineHeight: 1.3,
  },
  "& .step4-meta-unit-value": {
    display: "flex",
    flexDirection: "column",
  },
  "& .step4-meta-unit-line": {
    display: "block",
    overflowWrap: "anywhere",
  },
  "& .step4-meta-context": {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
    minWidth: 0,
    paddingLeft: "16px",
    borderLeft: "1px solid #e5e5e5",
  },
  "& .step4-meta-context-value": {
    display: "block",
    fontSize: "11px",
    fontWeight: 400,
    color: "#565656",
    lineHeight: 1.45,
    overflowWrap: "anywhere",
  },
  "& .step4-meta-context-clamp": {
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  "& .step4-meta-context-toggle": {
    alignSelf: "flex-start",
    padding: 0,
    border: "none",
    background: "none",
    color: "#2f55d4",
    fontSize: "11px",
    fontWeight: 600,
    cursor: "pointer",
  },
  "& .step4-meta-context-toggle:hover": {
    textDecoration: "underline",
  },
  "& .step4-table.MuiPaper-root": {
    border: "1px solid #d6d6d6",
    borderRadius: "6px",
    boxShadow: "none",
    overflow: "auto",
  },
  "& .step4-table-inner": {
    minWidth: "1240px",
  },
  "& .step4-thead .step4-th.MuiTableCell-root": {
    background: "#9f9f9f",
    color: "#ffffff",
    fontWeight: 700,
    padding: "10px 12px",
    whiteSpace: "nowrap",
  },
  "& .step4-td.MuiTableCell-root": {
    color: "#565656",
    borderBottom: "1px solid #ececec",
    padding: "14px 12px",
    // !important: sesion-search.css fija "font-size" en todas las tablas de la app
    fontSize: "14px !important",
    lineHeight: 1.35,
    verticalAlign: "middle",
  },
  "& .step4-td-order": {
    width: "70px",
    whiteSpace: "nowrap",
  },
  "& .step4-td-nro": {
    width: "90px",
    textAlign: "center",
    fontWeight: 700,
    color: "#2f55d4",
  },
  "& .step4-td-tema": {
    maxWidth: "240px",
    wordBreak: "break-word",
  },
  "& .step4-td-desc": {
    maxWidth: "420px",
  },
  "& .step4-td-competencia": {
    minWidth: "290px",
    maxWidth: "360px",
  },
  // Mismo tamaño de letra que el resto de la fila
  "& .step4-td-competencia .MuiInputBase-input": {
    fontSize: "14px",
  },
  "& .step4-td-competencia .MuiFormHelperText-root": {
    marginLeft: 0,
    fontSize: "10px",
  },
  "& .step4-desc-preview": {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    fontSize: 14,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: "#6a6a6a",
    lineHeight: 1.4,
  },
  "& .step4-tr": {
    transition: "background 0.15s ease",
  },
  "& .step4-tr:hover": {
    background: "#fafafa",
  },
  "&.loading-table .step4-tr:hover": {
    background: "transparent",
  },
  "& .step4-actions-wrapper": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
  },
  "& .step4-action-inline.MuiButton-root": {
    padding: "8px 16px",
    minWidth: "160px",
    height: "40px",
    fontSize: "13px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    borderRadius: "10px",
    color: "#ffffff",
    justifyContent: "center",
  },
  "& .step4-action-inline.MuiButton-root:hover": {
    boxShadow: "none",
  },
  "& .step4-action-inline.MuiButton-root:not(.step4-action-edit)": {
    background: "#12b5cb",
  },
  "& .step4-action-inline.MuiButton-root:not(.step4-action-edit):hover": {
    background: "#0f9caf",
  },
  "& .step4-action-edit.MuiButton-root": {
    color: "#ffffff",
    background: "#5b6c8f",
  },
  "& .step4-action-edit.MuiButton-root:hover": {
    background: "#4b5b7a",
  },
  "& .step4-order-btn.MuiIconButton-root": {
    color: "#bdbdbd",
  },
  "& .step4-order-btn.MuiIconButton-root:hover": {
    background: "rgba(0, 0, 0, 0.04)",
  },
  "& .step4-btn.MuiButton-root": {
    borderRadius: "999px",
    height: "42px",
    padding: "0 22px",
    fontWeight: 800,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    boxShadow: "none",
  },
  "& .step4-btn.Mui-disabled": {
    opacity: 0.5,
  },
  "& .step4-action-inline.MuiButton-root.Mui-disabled": {
    opacity: 1,
    background: "#d7d7d7",
    color: "#ffffff",
  },
  "& .step4-btn-regenerate.MuiButton-contained, & .step4-btn-continue.MuiButton-contained": {
    background: "#00c7db",
    color: "#ffffff",
  },
  "& .step4-btn-regenerate.MuiButton-contained:hover, & .step4-btn-continue.MuiButton-contained:hover": {
    background: "#00a9b9",
  },
  "@media (max-width:900px)": {
    "& .step4-table-inner": {
      minWidth: "880px",
    },
    "& .step4-meta-compact": {
      gridTemplateColumns: "1fr",
      padding: "8px 12px",
      maxWidth: "100%",
    },
    "& .step4-meta-context": {
      paddingLeft: 0,
      paddingTop: "8px",
      borderLeft: "none",
      borderTop: "1px solid #e5e5e5",
    },
  },
  "@media (max-width:600px)": {
    padding: "0 1rem 1rem 1rem",
    "& .step4-title": {
      fontSize: "28px",
    },
    "& .step4-meta-line": {
      flexDirection: "column",
    },
    "& .step4-footer": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& .step4-btn.MuiButton-root, & .step4-btn-continue.MuiButton-root": {
      width: "100%",
    },
  },
};
